import { useState } from 'react';

import { useEventListener } from './hook-useEventListener';
export const useKeyPress = (target: string): boolean => {
  const [keyPressed, setKeyPressed] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function handleKeyDown({ key }: any): void {
    if (key === target) setKeyPressed(true);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function handleKeyUp({ key }: any): void {
    if (key === target) setKeyPressed(false);
  }
  useEventListener('keydown', handleKeyDown);
  useEventListener('keyup', handleKeyUp);
  return keyPressed;
};
